import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/components/Header";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";

const CompanyForm = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { id } = useParams(); // for edit
  const [initialValues, setInitialValues] = useState({
    name: "",
    description: "",
    website: "",
    videoLink: "",
  });
  const navigate = useNavigate();

  const checkoutSchema = yup.object().shape({
    name: yup.string().required("required"),
    description: yup.string(),
    website: yup.string().url("Enter a valid URL"),
    videoLink: yup.string().url("Enter a valid URL"),
  });

  // Fetch company for edit
  useEffect(() => {
    if (id) {
      axiosInstance
        .get(`/companies/${id}`)
        .then((res) => setInitialValues(res.data))
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleFormSubmit = (values, { setSubmitting }) => {
    const apiCall = id
      ? axiosInstance.put(`/companies/${id}`, values)
      : axiosInstance.post("/companies", values);

    apiCall
      .then((res) => {
        console.log(res.data);
        toast.success(`Company ${id ? "updated" : "added"} successfully`);
        navigate("/companies");
      })
      .catch((err) => toast.error(err.response?.data?.message || "Error"))
      .finally(() => setSubmitting(false));
  };

  return (
    <Box m="20px">
      <Header
        title={id ? "EDIT COMPANY" : "ADD COMPANY"}
        subtitle={id ? "Edit Company Details" : "Create a New Company"}
      />

      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Company Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Website"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.website}
                name="website"
                error={!!touched.website && !!errors.website}
                helperText={touched.website && errors.website}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Video Link"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.videoLink}
                name="videoLink"
                error={!!touched.videoLink && !!errors.videoLink}
                helperText={touched.videoLink && errors.videoLink}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {id ? "Update Company" : "Add Company"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CompanyForm;
